import { getApolloClient } from '@faustwp/core';
import { SEO } from '../../components';
import {
  Header,
  Footer,
  HeroSection,
  TeamMemberSection,
  FinalCTASection,
} from '../../components/sections';
import { fetchTeamMembers } from '../../lib/teamUtils';
import { fetchPageSettings } from '../../lib/queries/pageSettings';
import { getCanonicalUrl, buildHreflangTags } from '../../lib/siteUrl';

const FALLBACK_FI = {
  metaTitle: 'Tiimi | Identio',
  metaDescription:
    'Tiimi, jossa yhdistyvät kokemus ja uteliaisuus. Me olemme ohjelmistoalan ammattilaisia, UI/UX-suunnittelijoita ja markkinoinnin asiantuntijoita.',
  heroTitle: 'Tiimi, jossa yhdistyvät kokemus ja uteliaisuus.',
  heroDescription:
    'Me olemme ohjelmistoalan ammattilaisia, UI/UX-suunnittelijoita ja markkinoinnin asiantuntijoita. Olemme myös aktiivisia harrastajia ja sohvan nurkassa rentoutujia. Meitä kaikkia yhdistää se, että nautimme mahdollisuuksista kehittää entistä toimivampaa teknologiaa ja mikä parasta, saamme tehdä sitä hyvien ihmisten ympäröimänä.',
  heroPrimaryCta: 'Katso avoimet työpaikat',
  heroPrimaryCtaUrl: '/rekry#open-positions',
  teamEmptyMessage: 'Tiimin jäseneitä ei voitu ladata. Yritä myöhemmin uudelleen.',
};

export default function TiimiPage({ teamMembers = [], tiimiSettings = null }) {
  const s = tiimiSettings ?? {};
  const title = s.seoTitle ?? s.metaTitle ?? s.meta_title ?? FALLBACK_FI.metaTitle;
  const description = s.seoDescription ?? s.metaDescription ?? s.meta_description ?? FALLBACK_FI.metaDescription;
  const heroTitle = s.heroTitle ?? s.hero_title ?? FALLBACK_FI.heroTitle;
  const heroDescription = s.heroDescription ?? s.hero_description ?? FALLBACK_FI.heroDescription;
  const primaryCta = s.heroPrimaryCta ?? s.hero_primary_cta ?? FALLBACK_FI.heroPrimaryCta;
  const primaryHref = s.heroPrimaryCtaUrl ?? s.hero_primary_cta_url ?? FALLBACK_FI.heroPrimaryCtaUrl;
  const emptyMessage = teamMembers.length === 0
    ? (s.teamEmptyMessage ?? s.team_empty_message ?? FALLBACK_FI.teamEmptyMessage)
    : undefined;
  const ctaTitle = s.ctaTitle ?? s.cta_title ?? undefined;
  const ctaBody = s.ctaBody ?? s.cta_body ?? undefined;
  const ctaButtonText = s.ctaButtonText ?? s.cta_button_text ?? undefined;
  const ctaButtonUrl = s.ctaButtonUrl ?? s.cta_button_url ?? undefined;

  return (
    <>
      <SEO title={title} description={description} url={getCanonicalUrl('/tiimi')} alternates={buildHreflangTags('/tiimi', '/team')} />
      <Header />
      <main id="main-content" tabIndex={-1}>
        <HeroSection
          variant="team"
          title={heroTitle}
          description={heroDescription}
          primaryCta={primaryCta}
          primaryHref={primaryHref}
        />
        <TeamMemberSection teamMembers={teamMembers} emptyMessage={emptyMessage} />
        <FinalCTASection
          variant="team"
          title={ctaTitle}
          body={ctaBody}
          contactButtonText={ctaButtonText}
          contactButtonUrl={ctaButtonUrl}
        />
      </main>
      <Footer />
    </>
  );
}

export async function getStaticProps() {
  const client = getApolloClient();
  let teamMembers = [];
  let tiimiSettings = null;
  try {
    tiimiSettings = await fetchPageSettings(client, 'tiimi');
  } catch (e) {
    // ACF optional
  }
  try {
    const { teamMembers: members } = await fetchTeamMembers(client, 'fi');
    teamMembers = members ?? [];
  } catch (err) {
    console.error('[tiimi/index] getStaticProps failed', err);
  }
  return {
    props: { teamMembers, tiimiSettings },
    revalidate: 300,
  };
}
